app.controller('teacherSetupExercisesCtrl', [
    '$scope', '$rootScope', '$http', '$mdToast', '$state', 'mdContentService', 'simulatorService', function ($scope, $rootScope, $http, $mdToast, $state, mdContentService, simulatorService) {
    	var vm = this;

    	vm.selectedExercises = [];
    	vm.allExercises = [];
      vm.gameDay = null;
    	vm.loaded = false;

      vm.exerciseTooltipShown = [];
      vm.exerciseTooltipExpand = [];

   		$http.get('/api/gameday/exercises').then(function(response) {
   			vm.allExercises = response.data.items;
   			vm.selectedExercises = new Array(vm.allExercises.length);
        vm.exerciseTooltipShown = new Array(vm.allExercises.length);
   			
   			$http.get('/api/gameday').then(function(response) {
   				var gameDay = response.data;
   				for (var i = 0; i < vm.allExercises.length; i++) {
   					var exercise = vm.allExercises[i];
   					if (gameDay.exercises && gameDay.exercises.indexOf(exercise.id) !== -1) {
   						vm.selectedExercises[i] = true;
   					} else {
   						vm.selectedExercises[i] = false;
   					}
            vm.exerciseTooltipShown[i] = false;
            vm.exerciseTooltipExpand[i] = false;
   				}
          vm.gameDay = gameDay;
   				vm.loaded = true;

          mdContentService.triggerSyntheticScrollEvent();
   			});
   		});

        vm.previewExercise = function(exercise) {
            simulatorService.showFullExerciseFlowWithExercise(exercise);
        }

   		vm.save = function() {
   			var ids = [];
   			for (var i = 0; i < vm.allExercises.length; i++) {
   				var isSelected = vm.selectedExercises[i];
   				if (isSelected) {
   					var exercise = vm.allExercises[i];
   					ids.push(exercise.id);
   				}
   			}

   			var gdpe = {
   				exercises: ids,
   			}

            $http.post('/api/gameday/setupexercises', gdpe, {headers: {'Content-Type': 'application/json'}})
                .then(function (resp) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent("Opgaver valgt")
                        .position('top right')
                        .hideDelay(3000)
                    );
                    $state.go('teacher.setupgroups');
                });
   		}
    }
]);